// extracted by css-extract-rspack-plugin
export default {"zoomModal":"_3c71a7e5","hoverZoomWrapper":"_64984a5b","hoverZoomInner":"_90d38bb6"};